import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_37jvy57d59: FaireBrandEntity = {
  token: "b_37jvy57d59",
  type: "brand",
  name: "Electric Tides",
  avatarUrl:
    "https://cdn.faire.com/fastly/d8c0bb3bf332463baa49fdcc72347347309d9f2d8bf04b56f1ef1686db1b2408.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e268a521e0450c488811fa084743be176408201920149c0a049908cda3e8c23c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d8c0bb3bf332463baa49fdcc72347347309d9f2d8bf04b56f1ef1686db1b2408.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e268a521e0450c488811fa084743be176408201920149c0a049908cda3e8c23c.jpeg",
  location: "Aptos, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 5,
  isInsider: true,
  description:
    "Electric Tides is a home fragrance brand hand poured by the beach in Aptos, CA.",
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:14:08.314Z",
    importedBy: "entity-db-cli",
  },
};
